import * as React from 'react';

const BluePreviewIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 220 234" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <path
                    d="M86.168 88.019c-.732 2.038 2.495-.657-1.787-20.055-3.207-14.531-9.612-28.159-9.612-43.043v-2.186C74.769 10.73 84.469 1 96.432 1h49.524l-10.94 23.046-29.285 47.33-25.259 30.612 5.696-13.97z"
                    fill="#003D40"
                />
                <path
                    fill="#A3DBE2"
                    d="M119.018 107.524l-9.656-40.297-17.331 18.868 10.082 24.311z"
                />
                <path
                    d="M133.758 62.295c-.603-5.47-1.782-12.686-1.782-12.686l5.223-.928-2.183-24.635s-3.551 3.369-9.186 7.91c-5.447 4.39-16.671 4.656-16.671 9.656.86 10.69-6.015 10-6.015 10 .344-4.138-3.266-9.655-8.679-6.897-5.413 2.759-5.07 8.104-2.492 11.035 2.578 2.931 11.171 6.725 4.984 17.931-15.983 26.726-42.449 36.725-42.449 36.725h73.728l-9.613-8.948c-3.78-9.138-6.688-10.88-11.5-10.88s-8.249-5.69 8.078-8.62c23.284-3.264 18.938-10.634 18.904-14.951-1.52-.058-5.39-.525-6.936-3.726.013.003 4.549-.679 6.589-.986z"
                    fill="#A3DBE2"
                />
                <path
                    d="M57.273 107.035l-7.518-.753s-27.322 7.203-27.322 41.459v80.617h18.61l6.237-80.289 10.788 5.379.294 81.47h97.988l.023-57.267-99.1-70.616z"
                    fill="#FEFEFE"
                />
                <path
                    d="M156.359 194.407H48.517v-79.212c0-7.649 6.181-13.85 13.805-13.85h80.232c7.625 0 13.805 6.201 13.805 13.85v79.212z"
                    fill="#01808C"
                />
                <path
                    d="M159.99 130.117s-4.609-8.049-4.609-5.639v8.564h-8.023c-3.755 0-5.12.685-5.12 7.535v5.5c0 2.479 1.479 4.03 3.755 4.991l9.217 3.893.171 24.072 35.107 19.928-15.128-25.118s-9.679-9.486-11.444-19.738c-2.44-14.167-3.926-23.988-3.926-23.988z"
                    fill="#FEFEFE"
                />
                <path
                    fill="#FEFEFE"
                    d="M171.42 164.408l-16.09 12.825v14.893l22.27 16.965 16.393-13.653z"
                />
                <path
                    d="M48.9 158.496v31.96s.928 25.136 26.6 25.136c25.671 0 23.97-24.05 23.97-24.05h100.367s8.351 24.05-16.702 24.05H74.197"
                    fill="#A3DBE2"
                />
                <path
                    d="M48.9 158.496v31.96s.928 25.136 26.6 25.136c25.671 0 23.97-24.05 23.97-24.05L48.9 158.497zM152.05 98.066H52.8a4.29 4.29 0 00-4.284 4.298v12.413h107.816v-12.413a4.29 4.29 0 00-4.283-4.298"
                    fill="#01808C"
                />
                <path
                    d="M56.25 106.103c0 .628-.508 1.137-1.134 1.137a1.136 1.136 0 01-1.135-1.137c0-.629.509-1.138 1.135-1.138s1.134.509 1.134 1.138M60.683 106.103c0 .628-.508 1.137-1.134 1.137a1.136 1.136 0 01-1.134-1.137c0-.629.508-1.138 1.134-1.138.626 0 1.134.509 1.134 1.138M65.116 106.103c0 .628-.508 1.137-1.133 1.137a1.136 1.136 0 01-1.135-1.137 1.136 1.136 0 112.268 0"
                    fill="#CAFFFF"
                />
                <path
                    d="M50.43 141.166h-1.387v-9.08c0-4.723-4.889-5.086-4.889-5.086s-.905 21.612-4.163 36.506C36.732 178.398 17 209.156 17 232.948c0 .68.032 1.782.081 2.422h30.79c.055-.64.085-1.744.085-2.422 0-22.521 1.268-67.808 1.268-67.808l9.774-4.129a6.531 6.531 0 003.984-6.018v-5.836c0-7.265-1.449-7.99-5.43-7.99H50.43z"
                    fill="#A3DBE2"
                />
                <path d="M0 0h220v234H0z" />
            </g>
        </g>
    </svg>
);

BluePreviewIllustrationSvg.displayName = 'BluePreviewIllustrationSvg';
export default BluePreviewIllustrationSvg;
